import { connect } from 'react-redux';
import { pushUserSymbolsPopup } from '../../../UserSymbolsPopup/actions';
var mapDispatchToProps = {
    pushUserSymbolsPopup: pushUserSymbolsPopup,
};
export default connect(undefined, mapDispatchToProps);
//# sourceMappingURL=UserCoreBadge.container.js.map